export const allowedPincodes = [
  "304185", "304516", "304518", "335009", "394006", "394010", "394105", "394107",
  "394210", "394212", "394220", "394221", "394229", "394230", "394235", "394305",
  "394325", "394500", "394510", "394820", "394850", "395001", "395002", "395003",
  "395004", "395005", "395007", "395008", "395009", "395010", "395011", "395012",
  "395013", "395017", "395023", "395101", "395210", "395006","394101","394104","394185","394211","394516","394518","394520","394550",
  "394150","395620","394651","394355","394246","394365","394120"
];